export default __webpack_public_path__ + "static/media/logoLight.65a46ad2.svg";